import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchQuoteTemplates } from 'api/quotes';
import { pushSiteError } from 'containers/App/actions';
import * as types from './types';

const getErrorMessage = 'We could get your quote templates. Please refresh and try again.';

function* getQuoteTemplates(action) {
  const { payload } = action || {};
  const { orgId } = payload || {};
  if (!orgId) {
    yield put(pushSiteError({ getErrorMessage }));
  }

  try {
    const response = yield call(fetchQuoteTemplates, payload);
    if (response.ok) {
      yield put({ type: types.ADD_QUOTE_TEMPLATES, data: response.data });
    } else {
      yield put(pushSiteError({ getErrorMessage }));
    }
  } catch (err) {
    yield put(pushSiteError({ getErrorMessage }));
  }
};

export default function* watchList() {
  yield takeLatest(types.GET_QUOTE_TEMPLATES, getQuoteTemplates);
};
